// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import useCurrentBreakpointIndex from "@store/Framework/Common/Hooks/useCurrentBreakpointIndex";
import fieldDefinitionBuilder from "@store/Framework/Common/Utilities/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import { useDisplayName } from "@store/Framework/Store/Foundation/Context/ContextHooks";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import parse from "html-react-parser";
import React from "react";

enum fields {
    titleStyle = "titleStyle",
    titleText = "titleText",
    alignment = "alignment",
    useCustomColor = "useCustomColor",
    customColor = "customColor",
}

interface LoggedInGreetingProps extends WidgetProps {
    fields: {
        [fields.titleText]: string;
        useResponsiveOptions: boolean;
        responsive: {
            fields: {
                [fields.titleText]: string;
            };
        }[];
    };
}

const getResponsiveTitleText = (fields: LoggedInGreetingProps["fields"], currentBreakpointIndex: number) => {
    if (fields.useResponsiveOptions) {
        return fields.responsive?.[currentBreakpointIndex - 1]?.fields.titleText ?? fields.titleText;
    }
    return fields.titleText;
};
const LoggedInGreeting: React.FunctionComponent<LoggedInGreetingProps> = ({ fields }: LoggedInGreetingProps) => {
    const userName = useDisplayName();
    const isInShell = useShellContext().isInShell;
    const isLoggedIn = useIsSignedInAndhasToBeSignedIn();
    const userNameToUse = isInShell ? "Bunzl" : userName;
    const currentBreakpointIndex = useCurrentBreakpointIndex();
    const responsiveTitleText = getResponsiveTitleText(fields, currentBreakpointIndex ?? 0);
    const titleTextWithUserName = responsiveTitleText.replace("{0}", userNameToUse);
    if (currentBreakpointIndex === null) {
        return null;
    }
    if (!isLoggedIn && !isInShell) {
        return null;
    }
    return <>{parse(titleTextWithUserName, parserOptions)}</>;
};

const widgetModule: WidgetModule<FoundationFieldDefinition> = {
    component: LoggedInGreeting,
    definition: {
        group: "Basic",
        icon: "Text",
        fieldDefinitions: fieldDefinitionBuilder([
            {
                name: fields.titleText,
                displayName: "Title",
                editorTemplate: "RichTextField",
                defaultValue: "Greeings {0}, Track Your latest activities here",
                isRequired: false,
                fieldType: "Contextual",
            },
        ]),
    },
};

export default widgetModule;
